/** Dimensiones A4 para vista previa / PDF (96 DPI). */
export const CONTRATO_A4 = {
  anchoMm: 210,
  altoMm: 297,
  paddingMm: { top: 18, right: 20, bottom: 20, left: 20 },
};

export function mmToPx(mm) {
  return (mm * 96) / 25.4;
}

export function obtenerMedidasPaginaContrato() {
  const { anchoMm, altoMm, paddingMm } = CONTRATO_A4;
  const anchoPx = mmToPx(anchoMm);
  const altoPx = mmToPx(altoMm);
  const paddingTopPx = mmToPx(paddingMm.top);
  const paddingBottomPx = mmToPx(paddingMm.bottom);
  const paddingLeftPx = mmToPx(paddingMm.left);
  const paddingRightPx = mmToPx(paddingMm.right);
  const anchoContenidoPx = anchoPx - paddingLeftPx - paddingRightPx;
  const altoContenidoPx = altoPx - paddingTopPx - paddingBottomPx;

  return {
    anchoPx,
    altoPx,
    paddingTopPx,
    paddingBottomPx,
    paddingLeftPx,
    paddingRightPx,
    anchoContenidoPx,
    altoContenidoPx,
  };
}
